import { Component, computed, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'allas-warranty-guard',
  imports: [CommonModule, DialogModule],
  template: `
    <div class="flex items-center gap-1 {{ styleClass }} fs-condensed">
      <!-- <img [src]="imageUrl()" alt="Warranty Shield" class="w-6 h-6" /> -->
      <span
        class="w-6 h-6 bg-appPrimary-500 rounded-lg flex items-center justify-center text-xs text-white font-semibold"
      >
        {{ months }}
      </span>
      <p
        class="text-sm cursor-pointer hover:text-allasRed transition-colors"
        (click)="openWarrantyModal($event)"
      >
        {{ text }}
      </p>
    </div>

    <!-- Modal de Garantía -->
    <p-dialog
      [(visible)]="showWarrantyModal"
      [modal]="true"
      [closable]="true"
      [dismissableMask]="true"
      [draggable]="false"
      [resizable]="false"
      [showHeader]="true"
      header="GARANTÍA LIMITADA DE BATERÍA"
      [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
      [maximizable]="true"
      headerStyleClass="fs-condensed"
    >
      <div class="space-y-4 fs-condensed">
        <!-- Advertencia de que la info no es ofical, debe ser declarado por el cliente -->
        <div class="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
          <h4 class="font-semibold text-yellow-800 mb-2">Advertencia:</h4>
          <p class="text-sm text-yellow-700">
            La información de la garantía no es oficial, debe ser declarada por
            el cliente.
          </p>
        </div>
        <!-- Tabla de Garantías -->
        <div class="overflow-x-auto">
          <table class="w-full border-collapse">
            <thead>
              <tr class="bg-gray-100">
                <th
                  class="border border-gray-300 px-4 py-2 text-left font-semibold"
                >
                  Tipo de Batería
                </th>
                <th
                  class="border border-gray-300 px-4 py-2 text-left font-semibold"
                >
                  Período de Reemplazo Gratuito
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-white hover:bg-gray-50 transition-colors">
                <td class="border border-gray-300 px-4 py-2">
                  TAB AGM STOP & GO
                </td>
                <td class="border border-gray-300 px-4 py-2">
                  5 años / 60 meses
                </td>
              </tr>
              <tr class="bg-gray-50 hover:bg-gray-100 transition-colors">
                <td class="border border-gray-300 px-4 py-2">TAB 5G</td>
                <td class="border border-gray-300 px-4 py-2">
                  4 años / 48 meses
                </td>
              </tr>
              <tr class="bg-white hover:bg-gray-50 transition-colors">
                <td class="border border-gray-300 px-4 py-2">TAB POLAR</td>
                <td class="border border-gray-300 px-4 py-2">
                  3 años / 36 meses
                </td>
              </tr>
              <tr class="bg-gray-50 hover:bg-gray-100 transition-colors">
                <td class="border border-gray-300 px-4 py-2">Otras Marcas</td>
                <td class="border border-gray-300 px-4 py-2">
                  2 años / 24 meses
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Información Adicional -->
        <div class="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <h4 class="font-semibold text-blue-800 mb-2">
            Términos y Condiciones:
          </h4>
          <ul class="text-sm text-blue-700 space-y-1">
            <li>• La garantía cubre defectos de fabricación</li>
            <li>• No cubre daños por mal uso o instalación incorrecta</li>
            <li>• Requiere presentación de factura original</li>
            <li>• Válida solo en territorio hondureño</li>
          </ul>
        </div>
      </div>
    </p-dialog>
  `,
})
export class WarrantyGuard {
  // TODO: Eliminar este input, ya que no se usa.
  // @Input({ required: true }) years = 1;
  @Input({ required: true }) months = 12;
  @Input() text = 'meses de garantía';
  @Input() styleClass = '';

  showWarrantyModal = false;

  openWarrantyModal(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.showWarrantyModal = true;
  }

  // imageUrl = computed(() => `/warranty-shield/${this.years}.svg`);
}
